(function () {
  function init(root) {
    if (!root) return;

    var track = root.querySelector('[data-mnl-track]');
    var bar = root.querySelector('[data-mnl-bar]');
    if (!track || !bar) return;

    // Scroll bar under the track (thumb = ::before, see mnl-subcollection-slider.css): thumb size and
    // position, both from 0 to 1. Hidden when nothing scrolls.
    function updateProgress() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      bar.hidden = maxScroll <= 0;
      bar.style.setProperty('--mnl-progress-size', track.clientWidth / track.scrollWidth);
      bar.style.setProperty('--mnl-progress-pos', maxScroll > 0 ? track.scrollLeft / maxScroll : 0);
    }

    // Drag the thumb, or press the rail to bring it there: a mouse cannot swipe the cards.
    bar.addEventListener('pointerdown', function (e) {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) return;
      var rect = bar.getBoundingClientRect();
      var inner = rect.width - 6; // the thumb is inset 3px at each end
      var thumbW = (inner * track.clientWidth) / track.scrollWidth;
      var thumbX = rect.left + 3 + (inner - thumbW) * (track.scrollLeft / maxScroll);
      // Keep the grabbed point under the pointer; from the rail, centre the thumb on it.
      var grab = e.clientX >= thumbX && e.clientX <= thumbX + thumbW ? e.clientX - thumbX : thumbW / 2;

      function follow(ev) {
        var p = (ev.clientX - rect.left - 3 - grab) / (inner - thumbW);
        track.scrollLeft = Math.min(1, Math.max(0, p)) * maxScroll;
      }

      function release() {
        bar.removeEventListener('pointermove', follow);
        bar.removeEventListener('pointerup', release);
        bar.removeEventListener('pointercancel', release);
        track.classList.remove('is-dragging');
      }

      e.preventDefault();
      bar.setPointerCapture(e.pointerId);
      track.classList.add('is-dragging');
      follow(e);
      bar.addEventListener('pointermove', follow);
      bar.addEventListener('pointerup', release);
      bar.addEventListener('pointercancel', release);
    });

    // Mouse: grab the cards and drag them, like a swipe (touch scrolls natively).
    var drag = null;
    var dragged = false;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { id: e.pointerId, x: e.clientX, left: track.scrollLeft, moved: false };
    });

    track.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved) {
        if (Math.abs(dx) < 5) return; // below that it is a click and opens the collection
        drag.moved = true;
        track.setPointerCapture(drag.id);
        track.classList.add('is-dragging');
      }
      track.scrollLeft = drag.left - dx;
    });

    function endDrag() {
      if (!drag) return;
      dragged = drag.moved;
      drag = null;
      track.classList.remove('is-dragging');
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    // The browser's own image/link drag would take over the pointer.
    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    // A drag must not end by opening the card it was released on.
    track.addEventListener(
      'click',
      function (e) {
        if (!dragged) return;
        dragged = false;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );

    track.addEventListener('scroll', updateProgress);
    window.addEventListener('resize', updateProgress);

    // initial state
    updateProgress();
  }

  function initAll() {
    document.querySelectorAll('[data-mnl-subcoll-root]').forEach(init);
  }

  // First load
  document.addEventListener('DOMContentLoaded', initAll);

  // Theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target;
    if (!container) return;
    container.querySelectorAll('[data-mnl-subcoll-root]').forEach(init);
  });
})();